import { render, staticRenderFns } from "./InvoiceDesign.vue?vue&type=template&id=f5a31404&scoped=true&"
import script from "./InvoiceDesign.vue?vue&type=script&lang=js&"
export * from "./InvoiceDesign.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDesign.vue?vue&type=style&index=0&id=f5a31404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a31404",
  null
  
)

export default component.exports